import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { validateEmail } from '@/functions/Util';

export default class UsuarioValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs, hasNewPassword) {
        let validated = true;
        let validatedField = true;
        let usuario = model;
        if (!usuario.nome) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }
        if (!usuario.login) {
            refs.loginInput.focusedOut = true;
            validated = false;
        }

        if (hasNewPassword) {
            if(usuario.novaSenha!=usuario.confirmeNovaSenha){
                refs.novaSenhaInput.focusedOut = true;
                refs.confirmeNovaSenhaInput.focusedOut = true;
                this.showMessage(new Message('alert', 'msg-senhas-diferentes', true));
                validated = false;
            }
            if(!usuario.novaSenha || !usuario.confirmeNovaSenha){
                refs.novaSenhaInput.focusedOut = true;
                refs.confirmeNovaSenhaInput.focusedOut = true;
                this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
                validated = false;
            }
        }
            
        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        if (usuario.login && !validateEmail(usuario.login)) {
            validated = false;
            validatedField = false;
        }
        if (!validatedField) {
            this.showMessage( new Message('alert', 'msg-campos-invalidos', true) );  
        }
        return validated;
    }

}